/*
 * Footer Module
 */

define([
  "marionette",
  "jquery",
  "moment",
  "backbone",
  "messaging/messenger",
  "configuration/properties",
  "modules/footer/footerView",
], function (Marionette, $, Moment, Backbone, Messenger, Properties, FooterView) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "footer";
      this.region = options.region;
    },
    show: function () {
      const model = new Backbone.Model({
        footerText: $.t("footer.text", {
          applicationName: Properties.applicationName,
          buildDate: Messenger.reqres.request("get:buildDate"),
          version: Messenger.reqres.request("get:version"),
        }),
      });
      this.view = new FooterView.footerView({ model: model });
      this.showRegion(this.view);
    },
  });
});
